import { useScenario } from '../contexts/ScenarioContext';

interface ScenarioMode {
  isScenarioActive: boolean;
  isScenarioEditing: boolean;
  isScenarioViewOnly: boolean;
  scenarioName: string | null;
  scenarioLabel: (name?: string, maxLength?: number) => string | undefined;
}

const useScenarioMode = (): ScenarioMode => {
  const { activeScenario } = useScenario();

  const isScenarioActive = activeScenario !== null;
  const isScenarioEditing = activeScenario?.mode === 'EDITING';
  const isScenarioViewOnly =
    isScenarioActive && activeScenario?.mode === 'VIEW';
  const scenarioName = activeScenario?.name ?? null;

  const scenarioLabel = (
    name: string | undefined,
    maxLength = 20
  ): string | undefined => {
    if (!scenarioName) return name;
    const truncated =
      scenarioName.length > maxLength
        ? scenarioName.slice(0, maxLength) + '…'
        : scenarioName;
    return `${name || ''} (${truncated})`;
  };

  return {
    isScenarioActive,
    isScenarioEditing,
    isScenarioViewOnly,
    scenarioName,
    scenarioLabel,
  };
};

export default useScenarioMode;
